import React, { useState } from "react";
import { Layout, Menu, Avatar, Space, Typography, theme, Modal } from "antd";
import {
  DashboardOutlined,
  UserOutlined,
  ShoppingOutlined,
  CalendarOutlined,
  FileTextOutlined,
  TeamOutlined,
  HomeOutlined,
  DollarOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PauseCircleOutlined,
  AppstoreOutlined,
  LoginOutlined,
} from "@ant-design/icons";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const siderWidth = 250; // เพิ่มจาก 200 เป็น 250
  const collapsedWidth = 80;

  const menuItems = [
    {
      key: "/",
      icon: <DashboardOutlined />,
      label: "ໜ້າຫຼັກ",
    },
    {
      key: "/reports-customer",
      icon: <FileTextOutlined />,
      label: "ລາຍການລູກຄ້າ ແລະ ຄອສ",
    },
    {
      key: "customer-management",
      icon: <UserOutlined />,
      label: "ຈັດການລູກຄ້າ",
      children: [
        {
          key: "/customers",
          icon: <UserOutlined />,
          label: "ລາຍການລູກຄ້າ",
        },
        {
          key: "/customer-courses",
          icon: <PauseCircleOutlined />,
          label: "ຄອສກຳລັງໃຊ້ງານ",
        },
      ],
    },
    {
      key: "service-management",
      icon: <AppstoreOutlined />,
      label: "ຈັດການບໍລິການ",
      children: [
        {
          key: "/services",
          icon: <AppstoreOutlined />,
          label: "ບໍລິການ ແລະ ສິນຄ້າ",
        },
        {
          key: "/courses",
          icon: <ShoppingOutlined />,
          label: "ຈັດການຄອສ",
        },
        ...(user?.role === "admin" || user?.role === "cashier"
          ? [
              {
                key: "/rooms",
                icon: <HomeOutlined />,
                label: "ຈັດການຫ້ອງ",
              },
            ]
          : []),
      ],
    },
    {
      key: "booking-management",
      icon: <CalendarOutlined />,
      label: "ການຈອງ ແລະ ບໍລິການ",
      children: [
        {
          key: "/bookings",
          icon: <CalendarOutlined />,
          label: "ຈັດການຈອງ",
        },
        {
          key: "/service-records",
          icon: <FileTextOutlined />,
          label: "ບັນທຶກການໃຊ້ບໍລິການ",
        },
        {
          key: "/service-charge",
          icon: <FileTextOutlined />,
          label: "ບັນທຶກໃຫ້ບໍລິການ",
        },
      ],
    },
    {
      key: "financial-management",
      icon: <DollarOutlined />,
      label: "ການເງິນ",
      children: [
        {
          key: "/receipts",
          icon: <FileTextOutlined />,
          label: "ອອກບິນເກັບເງິນ",
        },
        ...(user?.role === "admin" || user?.role === "cashier"
          ? [
              {
                key: "/exchanges",
                icon: <DollarOutlined />,
                label: "ອັດຕາແລກປ່ຽນ",
              },
            ]
          : []),
      ],
    },
    ...(user?.role === "admin" || user?.role === "cashier"
      ? [
          {
            key: "employee-management",
            icon: <TeamOutlined />,
            label: "ຈັດການພະນັກງານ",
            children: [
              {
                key: "/employees",
                icon: <TeamOutlined />,
                label: "ຂໍ້ມູນພະນັກງານ",
              },
              {
                key: "/attendance",
                icon: <TeamOutlined />,
                label: "ເວລາເຂົ້າວຽກ",
              },
              {
                key: "/salaries",
                icon: <DollarOutlined />,
                label: "ຄິດໄລ່ເງິນເດືອນ",
              },
              {
                key: "/service-bonus",
                icon: <DollarOutlined />,
                label: "ໂບນັດບໍລິການ",
              },
            ],
          },
        ]
      : []),

    // {
    //   key: "reports-management",
    //   icon: <BarChartOutlined />,
    //   label: "ພາບລວມ ແລະ ລາຍງານ",
    //   children: [
    //     {
    //       key: "/reports",
    //       icon: <FileTextOutlined />,
    //       label: "ລາຍງານ",
    //     },
    //     {
    //       key: "/reports-customer",
    //       icon: <FileTextOutlined />,
    //       label: "ລາຍການລູກຄ້າ ແລະ ຄອສ",
    //     },
    //   ],
    // },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    if (location.pathname === key) {
      return;
    }
    navigate(key);
  };

  const handleLogout = () => {
    Modal.confirm({
      title: "ຢືນຢັນອອກຈາກລະບົບ",
      content: (
        <div>
          <p>ທ່ານຕ້ອງການອອກຈາກລະບົບແທ້ ຫຼື ບໍ່ ?</p>
        </div>
      ),
      okText: "ຢືນຢັນ",
      okType: "danger",
      cancelText: "ຍົກເລີກ",
      onOk: () => {
        logout();
        navigate("/login");
      },
    });
  };

  // const userMenu = {
  //   items: [
  //     {
  //       key: "profile",
  //       icon: <SettingOutlined />,
  //       label: "ຕັ້ງຄ່າບັນຊີ",
  //       onClick: () => navigate("/profile"),
  //     },
  //     {
  //       type: "divider" as const,
  //     },
  //     {
  //       key: "logout",
  //       icon: <LogoutOutlined />,
  //       label: "ອອກຈາກລະບົບ",
  //       danger: true,
  //       onClick: handleLogout,
  //     },
  //   ],
  // };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={siderWidth} // เพิ่มความกว้างเมื่อไม่ collapse
        collapsedWidth={collapsedWidth} // ความกว้างเมื่อ collapse
        style={{
          overflow: "auto",
          height: "100vh",
          position: "fixed",
          left: 0,
          top: 0,
          bottom: 0,
          boxShadow: "2px 0 8px rgba(0,0,0,0.05)",
        }}
      >
        {/* Logo Section */}
        <div
          style={{
            height: 64,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            margin: 0,
            padding: "0 16px",
          }}
        >
          {collapsed ? (
            // แสดงเฉพาะโลโก้เมื่อ collapse
            <img
              src="/lpylogo.png" // เปลี่ยนเป็นพาธของรูปโลโก้
              alt="Logo"
              style={{
                height: 40,
                width: 40,
                objectFit: "contain",
                transition: "all 0.3s",
              }}
            />
          ) : (
            // แสดงโลโก้ + ชื่อเมื่อไม่ collapse
            <Space size="middle">
              <img
                src="/lpylogo.png" // เปลี่ยนเป็นพาธของรูปโลโก้
                alt="Logo"
                style={{
                  height: 40,
                  width: 40,
                  objectFit: "contain",
                  transition: "all 0.3s",
                }}
              />
              <div
                style={{
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "18px",
                  letterSpacing: "1px",
                  whiteSpace: "nowrap",
                }}
              >
                SPA LAOPAYOOK
              </div>
            </Space>
          )}
        </div>

        {/* Menu */}
        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={[location.pathname]}
          items={menuItems}
          onClick={handleMenuClick}
          style={{
            border: "none",
            marginTop: 8,
          }}
        />

        {/* User Info in Sidebar (when not collapsed) */}
        {!collapsed && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              padding: "16px",
              background: "rgba(255, 255, 255, 0.05)",
              borderTop: "1px solid rgba(255, 255, 255, 0.1)",
            }}
          >
            <Space>
              <Avatar
                size="small"
                style={{ backgroundColor: "#667eea" }}
                icon={<UserOutlined />}
              />
              <div>
                <Text
                  style={{ color: "white", fontSize: "12px", display: "block" }}
                >
                  {user?.name}
                </Text>
                <Text
                  style={{ color: "rgba(255,255,255,0.6)", fontSize: "11px" }}
                >
                  {user?.role === "admin" ? "ຜູ້ດູແລລະບົບ" : "ພະນັກງານ"}
                </Text>
              </div>
            </Space>
          </div>
        )}
      </Sider>

      <Layout
        style={{
          marginLeft: collapsed ? collapsedWidth : siderWidth,
          transition: "all 0.2s",
        }}
      >
        <Header
          style={{
            padding: "0 24px",
            background: colorBgContainer,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            position: "sticky",
            top: 0,
            zIndex: 1,
          }}
        >
          <Space size="large">
            <button
              style={{
                fontSize: "18px",
                width: 48,
                height: 48,
                border: "none",
                background: "none",
                cursor: "pointer",
                borderRadius: "8px",
                transition: "all 0.3s",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#f0f0f0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "none";
              }}
              onClick={() => setCollapsed(!collapsed)}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </button>

            {/* Breadcrumb หรือ Page Title */}
            <Text strong style={{ fontSize: "16px" }}>
              {menuItems.find((item) => item.key === location.pathname)
                ?.label || "ໜ້າຫຼັກ"}
            </Text>
          </Space>

          <Space size="large">
            {/* Notification */}
            {/* <Badge count={5} size="small">
              <BellOutlined 
                style={{ 
                  fontSize: '18px', 
                  cursor: 'pointer',
                  color: '#595959'
                }} 
              />
            </Badge> */}

            {/* User Menu */}
            {/* <Dropdown menu={userMenu} placement="bottomRight" arrow>
              <Space style={{ cursor: "pointer" }}>
                <div style={{ textAlign: "right" }}>
                  <Text strong style={{ display: "block", fontSize: "14px" }}>
                    {user?.name}
                  </Text>
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    {user?.role === "admin" ? "ຜູ້ດູແລລະບົບ" : "ພະນັກງານ"}
                  </Text>
                </div>
                <Avatar
                  style={{
                    backgroundColor:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    cursor: "pointer",
                    border: "2px solid #f0f0f0",
                  }}
                  icon={<UserOutlined />}
                />
              </Space>
            </Dropdown> */}

            <LoginOutlined
              style={{
                fontSize: "18px",
                cursor: "pointer",
                color: "#ff0000ff",
              }}
              onClick={handleLogout}
            />
          </Space>
        </Header>

        <Content
          style={{
            margin: "24px 24px 0",
            overflow: "initial",
          }}
        >
          <div
            style={{
              padding: 24,
              minHeight: "calc(100vh - 112px)",
              background: colorBgContainer,
              borderRadius: 12,
              boxShadow:
                "0 1px 2px rgba(0,0,0,0.03), 0 2px 6px rgba(0,0,0,0.03)",
            }}
          >
            {children}
          </div>
        </Content>

        {/* Footer */}
        <div
          style={{
            textAlign: "center",
            padding: "16px 24px",
            color: "#999",
            fontSize: "12px",
          }}
        >
          © 2025 SPA Management System. All rights reserved.
        </div>
      </Layout>
    </Layout>
  );
};

export default MainLayout;
